import React from 'react'
import classnames from 'classnames'
import getTextColorClass from '@bt-react/libs/getTextColorClass'
import { TimerProps, TimerState } from './types'
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds'
import getDateDiff from '@bt-react/libs/getDateDiff'

function fetchDateDiff (date): number | undefined {

  return typeof date !== 'undefined'
    ? differenceInMilliseconds(Date.now(), new Date(date))
    : date

}

class Timer extends React.Component<TimerProps, TimerState> {

  timeout: number | null = null

  state: TimerState = {
    dateDiff: undefined
  }

  static getDerivedStateFromProps (nextProps) {

    return {
      dateDiff: fetchDateDiff(nextProps.date)
    }

  }

  componentWillUnmount () {

    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }

  }

  componentDidMount () {

    this.setDateDiff()

  }

  componentDidUpdate (prevProps, prevState) {

    if (prevState.dateDiff !== this.state.dateDiff) {

      this.setDateDiff()

    }

  }

  setDateDiff = () => {

    this.timeout = window.setTimeout(() => {

      this.setState({ dateDiff: fetchDateDiff(this.props.date) })

    }, 1000)

  }

  getTextColor = () => {

    const { color = 'black', overrunColor = 'orange' } = this.props
    let timerColor = color

    if ((this.state.dateDiff && this.props.duration) && (this.state.dateDiff / 1000) >= this.props.duration) {

      timerColor = overrunColor

    }

    return getTextColorClass(timerColor)

  }

  render () {

    if (typeof this.state.dateDiff !== 'number' || this.props.date === '') return null

    const prefixText = this.props.prefixText || ''
    const timeObj = getDateDiff(this.props.date, { allowMinus: false })
    let time = ''
    if (this.props.format === 'numeric' && timeObj.toNumeric) time = timeObj.toNumeric()
    if (time === '' && timeObj.toString) time = timeObj.toString()

    const timerClasses = classnames(
      this.props.className,
      this.getTextColor()
    )

    return <span
      data-bdd={this.props['dataBdd'] || 'timer'}
      className={timerClasses}
    >
      { prefixText !== '' ? <><span className={this.props.prefixTextClassName} data-bdd={`${this.props['dataBdd'] || 'timer'}-text`} >{ prefixText }</span> { time }</> : time }
    </span>

  }

}

export default Timer
